import {useSelector} from 'react-redux';
import Selector from '../../selectors/components/winners';

export default () => {
    const {winners} = useSelector(Selector);

    return (
        <div className="winners">
            <div className="title">
                <div className="text">Winners</div>
            </div>

            <div className="winners-list">
                {winners.map((winner, key) => {
                    return (
                        <div className="winner-20" key={key}>
                            <div className="winner-content">
                                <div className="avatar">
                                    <img src={`${window.location.origin}/source/system/avatars/default.png`} alt="Avatar" />
                                </div>
                                <div className="details">
                                    <div className="amount">+{winner.amount} USD</div>
                                    <div className="username">
                                        <img src={`${window.location.origin}/source/system/vip20/levels/vip-20-level-${winner.user.vip}.png`} alt="Vip Level" />
                                        {winner.user.name}
                                    </div>
                                </div>
                                <div className="image" style={{backgroundImage: `url(${window.location.origin}/source/system/games/squad_new/${winner.game}.png)`}}></div>
                            </div>
                            <div className="winner-background">
                                <div className={`ellipse ${winner.type}`}></div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}